import { c as _c } from "react/compiler-runtime";
import { MentionedUser, ReferencedNft } from "@/entities/IDrop";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import DropListItemContentNft from "./nft-tag/DropListItemContentNft";
import DropListItemContentMention from "./DropListItemContentMention";
import { DropContentPartType } from "@/components/drops/view/part/DropPartMarkdown";
interface DropListItemContentMentionProps {
  readonly type: DropContentPartType.MENTION;
  readonly value: MentionedUser;
  readonly match: string;
}
interface DropListItemContentHashtagProps {
  readonly type: DropContentPartType.HASHTAG;
  readonly value: ReferencedNft;
  readonly match: string;
}
export type DropListItemContentPartProps = DropListItemContentMentionProps | DropListItemContentHashtagProps;
export default function DropListItemContentPart(t0) {
  const $ = _c(4);
  const {
    part
  } = t0;
  const {
    type,
    value
  } = part;
  switch (type) {
    case DropContentPartType.MENTION:
      {
        let t1;
        if ($[0] !== value) {
          t1 = <DropListItemContentMention user={value} />;
          $[0] = value;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case DropContentPartType.HASHTAG:
      {
        let t1;
        if ($[2] !== value) {
          t1 = <DropListItemContentNft nft={value} />;
          $[2] = value;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    default:
      {
        assertUnreachable(type);
      }
  }
}